<div class="side-bar__container">
  <div class="side-bar__header">
    <!--  -->
    <div class="side-bar__con-status card">
      <button
        type="button"
        class="side-bar__home-button"
        aria-label="Dashboard"
        title="Dashboard"
        (click)="goToDashboard()">
        <fa-icon [icon]="['fas', 'house']"></fa-icon>
      </button>
      <app-desktop-connection-status></app-desktop-connection-status>
    </div>
    <!--  -->
    <div class="side-bar__navigation" *ngIf="showSelectedPage()">
      <app-desktop-navigation [pageName]="currentPage()" (clicked)="goBack()"></app-desktop-navigation>
    </div>
    <!--  -->
    <div class="side-bar__person-info card" (click)="addInfoPanel()">
      <app-desktop-person-info></app-desktop-person-info>
    </div>
    <ng-container *ngFor="let info of infos(); let i = index">
      <div class="side-bar__info-panel card" (click)="showMoreInfo(info.title, info.text, i)">
        <app-info-panel [title]="info.title" [text]="info.text"></app-info-panel>
      </div>
    </ng-container>
  </div>
  <div class="side-bar__footer">
    <div class="side-bar__language-select">
      <app-desktop-language-select [languages]="languages" [selectedLanguage]="selectedLanguage" [helpLink]="state.helpLink" (languageChange)="onLanguageChange($event)"></app-desktop-language-select>
    </div>
    <div class="side-bar__build-info" [class.non-production]="!isProductionEnvironment" *ngIf="buildInfo() as info" [title]="info.buildDate | date:'medium'">
      <span>{{ info.buildNumber }}</span>
    </div>
  </div>
</div>
